import { datadogRum } from '@datadog/browser-rum';
import { useEffect } from 'react';

import { useLeadContext } from '~/provider/LeadProvider';

export function initializeDatadogRum() {
  const VITE_STAGE = import.meta.env.VITE_STAGE;
  const VITE_DDRUM_APP_ID = import.meta.env.VITE_DDRUM_APPLICATION_ID;
  const VITE_DDRUM_CLIENT_TOKEN = import.meta.env.VITE_DDRUM_CLIENT_TOKEN;
  const GIT_COMMIT_SHA = import.meta.env.VITE_GIT_COMMIT_SHA;
  const baseUrl = import.meta.env.VITE_MARKETPLACE_BASE_URL;

  if (['staging', 'uat', 'prod'].includes(VITE_STAGE)) {
    datadogRum.init({
      applicationId: VITE_DDRUM_APP_ID,
      clientToken: VITE_DDRUM_CLIENT_TOKEN,
      site: 'datadoghq.com',
      service: 'marketplace',
      env: VITE_STAGE,
      // Specify a version number to identify the deployed version of your application in Datadog
      version: GIT_COMMIT_SHA,
      sessionSampleRate: 100,
      sessionReplaySampleRate: 100,
      defaultPrivacyLevel: 'mask-user-input',
      trackUserInteractions: true,
      trackResources: true,
      trackLongTasks: true,
      silentMultipleInit: true,
      allowedTracingUrls: [baseUrl],
      enableExperimentalFeatures: ['feature_flags'],
    });
  }
}

export const DatadogRum = () => {
  const { lead } = useLeadContext();

  initializeDatadogRum();

  useEffect(() => {
    if (lead?.id) {
      datadogRum.setUser({
        id: lead.id,
        universalId: lead.universalId,
        name: lead.contact.firstName,
        postcode: lead.postcode,
      });
    }
  }, [lead]);

  return null;
};
